// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"acae40ee","453":"d2f31c9e","532":"7c98bbdf","635":"58e5fe5b","905":"26b4b0a3"}[chunkId] + ".chunk.js";
};